<template>
    <div class="my-habits-progress">

        <div>
            <!-- progress graph button -->
            <b-btn class="graph-button"
                   @click="editHabitProgress()">
                <my-habits-chart-progress size="sm"
                                          :habit="habit">
                </my-habits-chart-progress>

                <div class="graph-button__label">{{ $i18n.gt('LABEL_HABIT_PROGRESS') }}</div>
            </b-btn>

            <!-- modal -->
            <b-modal hide-footer
                     :id="modalId"
                     :title="$i18n.gt('LABEL_MY_HABITS_PROGRESS')">
                <b-alert show variant="info">
                    {{ habit.habit }}
                </b-alert>

                <div class="modal-section card p-2 light-bg">
                    <h5>{{ $i18n.gt('LABEL_MY_HABITS_TODAY') }}</h5>
                    <p>{{ $i18n.gt('LABEL_MY_HABITS_HOW_MUCH_PROGRESS') }}</p>

                    <my-habits-rating-slider :value="progressSliderValue"
                                             :on-update="progressSliderUpdated">
                    </my-habits-rating-slider>
                </div>

                <div class="entry-buttons text-center">
                    <b-btn variant="danger"
                           @click="cancelProgressEntry()">
                        {{ $i18n.gt('LABEL_CANCEL') }}
                    </b-btn>
                    <b-btn variant="primary" class="ml-3"
                           @click="addProgressEntry()">
                        {{ $i18n.gt('LABEL_MY_HABITS_ADD_ENTRY') }}
                    </b-btn>
                </div>

                <div class="modal-section">
                    <h4>{{ $i18n.gt('HEADING_MY_HABITS_HISTORY') }}</h4>
                    <my-habits-chart-progress size="lg"
                                              :habit="habit">
                    </my-habits-chart-progress>
                </div>

            </b-modal>

        </div>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import PatientPageMixin from "@/providers/PatientPageMixin";

/**
 * Button and modal to edit progress data for a wellness Habit
 */
export default Vue.extend({
    name: 'MyHabitsProgress',
    mixins: [PatientPageMixin],
    props: {
        habit: Object,
        index: Number
    },
    data() {
        return {
            progressSliderValue: 5,
        }
    },
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        modalId() {
            return `habitProgressModal_${this.index}`
        }
    },
    methods: {
        editHabitProgress() {
            this.$bvModal.show(this.modalId)
        },
        cancelProgressEntry() {
            this.$bvModal.hide(this.modalId)
            this.progressSliderValue = 5 // reset
        },
        addProgressEntry() {
            // TODO: restrict frequency of entries?
            if (!this.habit.progressEntries) {
                this.habit.progressEntries = []
            }
            this.habit.progressEntries.push({
                timestamp: new Date(),
                progress: this.progressSliderValue,
            })
            // console.log(this.habit)
            this.$bvModal.hide(this.modalId)
            this.progressSliderValue = 5
            this.saveParticipant()
        },
        progressSliderUpdated(uid, val) {
            this.progressSliderValue = val
        },
    },
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.my-habits-progress {
    display: inline-block;
}

</style>
